import { message } from 'antd';
import { useEffectOnce } from 'usehooks-ts';
import { unknownErrorToMessage } from '../../utils/unknowErrorToMessage';
import CustomRedirect from '../CustomRedirect';

export type RedirectWithErrorMessageProps = { to: string; error: unknown };

export function RedirectWithErrorMessage({ error, ...props }: RedirectWithErrorMessageProps) {
  useEffectOnce(() => {
    message.error(unknownErrorToMessage(error));
  });

  return <CustomRedirect {...props} />;
}
